module.exports = __webpack_public_path__ + "static/landing_spheres-18c7e02dfe0aeac92b6c506967743087.png";